import { useEffect, useMemo, useState } from "react";
// Hooks
import useSimulators from "../../hooks/useSimulators";
import { useGetSimulationsByClient } from "../../hooks/useSimulatorsQuery";
import { useParams } from "react-router-dom";
// Components
import Filtro from "./Filtro";
import ListagemItem from "./ListagemItem";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~/fetchs/useCliente";
import { useConfigureFooter } from "~hooks/useHelpers";
import useSimulacoes from "~/fetchs/useSimulacoes";
import Listagem from "./Listagem";
import useClientes from "~/fetchs/useClientes";
import useSimulacao from "~/fetchs/useSimulacao";
import Simulations from "~pages/Simulators/Simulations";

const AreaListagem = () => {
  useConfigureFooter({ notDeveloped: false });

  const { parameter: idCliente } = useParams();

  const [skipon, setSkipon] = useState(2);

  const {
    simulacoesSemFiltro,
    simulacoes,
    total,
    loading,
    filtersCliente: filters,
    setFiltersCliente: setFilters,
  } = useSimulacoes({
    type: idCliente ? "cliente" : "all", skip: 0, take: skipon
  });
  
  const { desconto } = useSimulacao();

  const { cliente } = useCliente(idCliente);

  const { options: clientes } = useClientes({
    type: "optionsSimulacao",
    formikRef: null,
    campo: "",
    restartFetch: false,
    skip: 0,
    take: 0,
    idCliente,
    enabledRequest: false
  });

  const [hasAnyFilters, setHasAnyFilters] = useState(false);

  useEffect(() => {
    const keys = Object.keys(filters);
    const anyFilter = Object.values(filters)?.filter((filter, index) => filter != "" && filter != 0 && keys[index] != 'orderBy')?.length > 0;

    setHasAnyFilters(anyFilter);
  }, [filters]);

  const simulacoesFiltro = useMemo(() => {
    const produtos = [];
    const gruposMateriais = [];
    (simulacoesSemFiltro || []).map((simulacao) => {
      produtos.push(simulacao.produtoId);
      gruposMateriais.push(simulacao.grupoMaterialId);
    })
    return { produtos, gruposMateriais };
  }, [simulacoesSemFiltro]);

  return (
    <>
      <ClientHeader dados={cliente} />
      <Filtro setFilters={setFilters} cliente={cliente} clientes={clientes} simulacoesFiltro={simulacoesFiltro} />

      {simulacoes && (
        <Listagem
          simulacoes={simulacoes}
          skip
          filter={filters}
          total={total}
          setSkipon={setSkipon}
          skipon={skipon}
          loading={loading}
          desconto={desconto}
          idCliente={idCliente}
          anyFilters={hasAnyFilters}
          cliente={cliente}
        />
      )}

      {(loading) && <div className="container text-center">Carregando...</div>}
    </>
  );
};

export default AreaListagem;
